(function() {
    'use strict';

    angular
        .module('claimsApp')
        .factory('ClaimRegistration', ClaimRegistration);

    ClaimRegistration.$inject = ['$resource','$window'];

    function ClaimRegistration ($resource,$window) {
        var resourceUrl =  GLOBAL_URL+'api/ga/claims/registration';
        return $resource(resourceUrl, {}, {
            'searchPolicy': {url:resourceUrl+'/search-policy', method: 'GET'},
        	'getReasons': {url:resourceUrl+'/get-reasons', method: 'GET',isArray: true},
            'getHospitals': {url:resourceUrl+'/get-api-claim-hospital', method: 'GET',isArray: true},
            'getDocumentRequireds': {url:resourceUrl+'/get-documents-required', method: 'GET',isArray: true},
            'getDocumentByType': {url:resourceUrl+'/get-documents-by-claim-type', method: 'GET',isArray: true},
            'getClaimCase':{url:resourceUrl+'/get-claim-case-by-txnid', method: 'GET'},
            'getPolicyLas':{url: resourceUrl+'/get-policy-las',isArray: true,method: 'GET'},
            'getReasonCancel':{url: resourceUrl+'/get-reason-cancel',isArray: true,method: 'GET'},
            'cancelCase':{url: resourceUrl+'/cancel-claim-case',method: 'POST'},
            'getHistory':{url: resourceUrl+'/claim-register-history',method: 'GET'},
            'checkPaymentOnSpot':{url: resourceUrl+'/check-payment-on-spot',method :'POST'},
            'checkCanClaim':{url: resourceUrl+'/check-can-claim',method :'POST'},
            'getSurgeries': {url:resourceUrl+'/get-surgeries', method: 'GET',isArray: true},
            'getClaimPayMethod': {url:resourceUrl+'/get-claim-pay-method', method: 'GET',isArray: true},
            'getClaimPolicyMethod': {url:resourceUrl+'/get-claim-policy-method', method: 'GET',isArray: true},
            'download': {
            	url:resourceUrl+'/print-claim-request-info',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: [function (data,header) {
                	var header = header();
                	if(data == null || data.byteLength == 0) return;
                	downLoad(data,header['file-type'],header['file-export']);
                }],
            }
            });
        /**
    	 * DownLoad report
    	 */
    	function downLoad(response, type, fileName) {
    			var file = new Blob([response], {type: type});
    		  if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
    	           $window.navigator.msSaveBlob(file, fileName);
    	       } else { // for other browsers
    	    	   var fileURL = $window.URL.createObjectURL(file);
    	    	   // Test tren chorme va firefox
  	    		 	var theAnchor = $('<a />')  
				        .attr('href', fileURL)  
				        .attr('download',fileName)
				        .attr('target','_blank')
				         .appendTo('body');
	 			    theAnchor[0].click();   
	 			    theAnchor.remove();  
    	       }
    		
    	};
    }
})();